import React from 'react';
import "./BlogPost.css";
import baje1 from '../../Assets/b69/baje1.jpg';
import baje2 from '../../Assets/b69/baje2.jpg';
import baje3 from '../../Assets/b69/baje3.jpg';
import baje4 from '../../Assets/b69/baje4.jpg';
import baje5 from '../../Assets/b69/baje5.jpg';
import baje6 from '../../Assets/b69/baje6.jpg';
import baje7 from '../../Assets/b69/baje7.jpg';

function Blog69(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Celebrating International Women’s Month this first Monday of March! 💜🩷✨</h1>
            <h6>March 2, 2026 at 06:01 PM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel carousel-dark slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="3" aria-label="Slide 4"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="4" aria-label="Slide 5"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="5" aria-label="Slide 6"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="6" aria-label="Slide 7"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={baje1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje3} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje4} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje5} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje6} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={baje7} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>Today, we recognize the strength, resilience, and invaluable contributions of women in every space — in leadership, in communities, in workplaces, and at home. Their passion, dedication, and courage continue to inspire progress and meaningful change.</p>
            <p>As we honor this month, may we continue to uplift one another, champion equality, and create opportunities where every woman can thrive and succeed.
                Here’s to empowered women empowering the world. 💪🌸</p>
            <p><a href='https://www.facebook.com/hashtag/mytsoftdevsolutions' target='_blank' className='blog-link'>
              #MYTSoftDevSolutions</a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood </a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog69;